import { call, getContext, put, takeEvery, all } from 'redux-saga/effects';
import BasketAPI from '../../../api/basket/BasketAPI';
import { basketActions } from '../../basket/actions/BasketActions.creators';
import { BasketActionTypes } from '../../../enums/ActionEnums';
import { getBasicBasket, getBasket } from './BasketSagas';
import { checkStockReservation } from './CheckStockReservationSaga';
import { BasketCartItemError, HTTPStatusCode } from '@as-react/common-types';
export function* updateProductQuantity(action) {
    var _a;
    try {
        const { defaultRequestParams, servicesEndpoint } = yield getContext('aemConfiguration');
        yield put(basketActions.createUpdateItemsErrorStateAction(null));
        const updateStatusObj = yield call(BasketAPI.updateQuantity, action.payload.product, servicesEndpoint, defaultRequestParams);
        yield put(basketActions.createGetBasicAction());
        yield put(basketActions.createGetAction());
        yield put(basketActions.createUpdateSuccessAction(action.payload.product, updateStatusObj.quantity));
    }
    catch (e) {
        const { response } = e;
        yield all([call(getBasicBasket), call(getBasket), call(checkStockReservation)]);
        yield put(basketActions.createUpdateItemsErrorStateAction(BasketCartItemError.ADD_FAILED, action.payload.product));
        if (response.status === HTTPStatusCode.BadRequest && ((_a = response.data) === null || _a === void 0 ? void 0 : _a.availableQuantity)) {
            yield put(basketActions.createUpdateSuccessAction(action.payload.product, response.data.availableQuantity));
        }
    }
}
export function* updateProductQuantitySaga() {
    yield takeEvery(BasketActionTypes.UPDATE_QUANTITY_CUSTOM, updateProductQuantity);
}
